import React from "react";

interface StepNavigationProps {
  currentStep: number;
}

const StepNavigation: React.FC<StepNavigationProps> = ({ currentStep }) => {
  const steps = ["DADOS GERAIS", "DADOS DA CRIANÇA", "FINALIZAÇÃO"];

  return (
    <div className="flex lg:mt-0 px-2 lg:px-0 items-center justify-between lg:w-full w-[360px]">
      {steps.map((label, index) => {
        const stepNumber = index + 1;
        const isCompleted = currentStep > stepNumber;
        const isCurrent = currentStep === stepNumber;

        return (
          <React.Fragment key={index}>
            <div className="flex flex-col items-center justify-center text-center gap-2">
              <div
                className={`
                  lg:w-12 lg:h-12 h-8 w-8 rounded-full flex items-center justify-center lg:text-xl text-sm font-bold
                  ${
                    isCompleted
                      ? "bg-[#018ED5] text-white"
                      : isCurrent
                      ? "border-2 border-[#018ED5] text-[#018ED5] bg-[#DBECFF]"
                      : "bg-[#DADAE7] text-white"
                  }
                `}
              >
                {isCompleted ? <img src="/icon-check-step.svg" /> : stepNumber}
              </div>
              <h2
                className={`lg:text-xs text-[9px] font-medium text-center ${
                  isCompleted || isCurrent ? "text-[#0168AC]" : "text-[#9195A1]"
                }`}
              >
                {label}
              </h2>
            </div>
            {index < steps.length - 1 && (
              <div
                className={`h-1 w-[100px] rounded-full mx-2 ${
                  currentStep > stepNumber ? "bg-[#018ED5]" : "bg-[#DADAE7]"
                }`}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default StepNavigation;
